import { render } from "./SnsView.vue?vue&type=template&id=70d33b27"
import script from "./SnsView.vue?vue&type=script&lang=js"
export * from "./SnsView.vue?vue&type=script&lang=js"

import "./SnsView.vue?vue&type=style&index=0&id=70d33b27&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vuemasi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__